<template>
  <div class="finance_list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        订单列表
        <div class="rutun" @click="setPage(1)">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>
    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;" class="search-box">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">输入搜索:</div>
          </el-col>
          <el-col :span="12">
            <template>
              <el-select size="small" v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-col>

          <el-col :span="5" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>

      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="orderCode" width="200" label="订单编号" align="center"></el-table-column>
        <el-table-column prop="address" label="订货人" align="center"></el-table-column>
        <el-table-column prop="pay_type" label="支付类型" align="center"></el-table-column>
        <el-table-column prop="payway" label="支付方式" align="center"></el-table-column>
        <el-table-column prop="pay_money" label="金额" align="center"></el-table-column>
        <el-table-column prop="create_time" width="200" label="下单时间" align="center"></el-table-column>
        <el-table-column label="操作" width="200" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button class="button1" @click="audit(scope.row.orderCode)">审核通过</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="foot">
        <div>
          <el-button @click="all_submit" size="small">选中审核通过</el-button>
        </div>
        <el-pagination
          hide-on-single-page
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="15"
          :current-page.sync="page"
          @current-change="setPage"
        ></el-pagination>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      order_list: "",
      serve: this.$store.state.serve,
      role: true,
      number: "",
      name: "",
      order: "",
      id: "",
      token: "",
      username: "",
      page: null,
      total: 0,
      resType: null,
      tableData: [],
      multipleSelection: [],
      isIndeterminate: true,
      select: false,
      selectAll: false,
      checked: [],
      options: [
        {
          label: "账期支付",
          value: "1"
        },
        {
          label: "支付宝支付",
          value: "2"
        },
        {
          label: "微信支付",
          value: "3"
        },
        {
          label: "余额支付",
          value: "4"
        },
        {
          label: "转账支付",
          value: "5"
        }
      ],
      value: "",
      page1: 1
    };
  },
  created() {
    this.$store.state.topActiveId = 3;
    this.$store.state.leftTitle = "订单确认";
    this.geting();
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleAllSelection();
      }
    }
  },
  methods: {
    all_submit() {
      this.axios
        .get(this.serve + "/admin/finance_check_agree", {
          params: {
            username: this.username,
            token: this.token,
            orderCodeList: this.order_list
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.setPage(this.page - 1);
            this.$message({
              type: "success",
              message: "操作成功"
            });
          } else if (res.data.state == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleSelectionChange(val) {
      var orderList = [];
      for (var i in val) {
        orderList.push(val[i].orderCode);
      }
      this.order_list = JSON.stringify(orderList);
    },
    audit(v) {
      this.$confirm("此操作审核订单, 是否确定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/finance_check_agree", {
              params: {
                username: this.username,
                token: this.token,
                orderCode: v
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.geting();
                this.$message({
                  type: "success",
                  message: "操作成功"
                });
              } else if (res.data.state == "error") {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    setType(type) {
      //点击分类 订单
      this.resType = type;
      this.geting();
    },
    setPage(v) {
      this.page = v;
      this.geting(v);
    },

    geting(page) {
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/finance_check_list", {
          params: {
            page: page,
            token: this.token,
            username: this.username,
            pay_type: this.value
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            that.tableData = [];
            var json = res.data.data;
            if (res.data.status == "success") {
              for (var key in json.results) {
                this.tableData.push(json.results[key]);
                if (json.results[key].pay_type == 1) {
                  json.results[key].pay_type = "在线支付";
                } else if (json.results[key].pay_type == 2) {
                  json.results[key].pay_type = "账期支付";
                }
                if (json.results[key].payway == 3) {
                  json.results[key].payway = "微信支付";
                } else if (json.results[key].payway == 2) {
                  json.results[key].payway = "支付宝支付";
                } else if (json.results[key].payway == 4) {
                  json.results[key].payway = "余额支付";
                } else if (json.results[key].payway == 5) {
                  json.results[key].payway = "后台支付";
                } else if (json.results[key].payway == 0) {
                  json.results[key].payway = "未支付";
                }
                var address = json.results[key].address;
                json.results[key].address = address.split(";")[1];
                var timeNew = new Date(
                  parseInt(json.results[key].create_time) * 1000
                )
                  .toLocaleString()
                  .replace(/:\d{1,2}$/, " ");
                json.results[key].create_time = timeNew;
              }

              that.total = json.total;
              that.page = Number(json.page);
            }
          } else {
            if (res.data.msg == "无权访问") {
              this.role = false;
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.finance_list {
  .foot {
    background: #fff;
    display: flex;
    justify-content: space-between;
    padding: 30px;
  }
  .search-box {
    width: 1054px;
    height: 86px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  background: #f5f5f5;

  color: #333;
  min-height: 1000px;
  padding-bottom: 100px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .search {
    display: flex;
    justify-content: left;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu1 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      margin-right: 0;
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>